import { useMemo } from "react";
import AnthropometricMetadataContext from "./contexts/AnthropometricMetadataContext";
import { AnthropometricsHelper } from "components/Chart/helpers";
import { useTranslation } from "react-i18next";

interface AnthropometricMetadataProviderProps {
  children?: React.ReactNode;
}

function AnthropometricMetadataProvider(props: AnthropometricMetadataProviderProps) {
  const anthropometricMetadata = useMemo(() => AnthropometricsHelper.metadata, []);
  const { t } = useTranslation();

  /**
   * @description Handle the translation of all anthropometric metadata names
   *
   * @important This is a special case to handle the translation, sorting and filtering of anthropometric metadata
   * We should always translate as close as the render as possible
   */
  const translatedAnthropometric = useMemo(() => {
    return anthropometricMetadata.map((anthropometric) => ({
      ...anthropometric,
      field: anthropometric.value,
      isDefault: false,
      sortType: 1 as const,
      isPbEnabled: false,
      name: t(`anthropometric_name_${anthropometric.value}`),
      label: t(`anthropometric_name_${anthropometric.value}`),
    }));
  }, [anthropometricMetadata, t]);

  return (
    <AnthropometricMetadataContext.Provider value={translatedAnthropometric}>
      {props.children}
    </AnthropometricMetadataContext.Provider>
  );
}

export default AnthropometricMetadataProvider;
